<div class="about-container">
  <div class="about-content">
    <!-- Logo Section -->
    <div class="logo-section">
      <img src="assets/logo-transparent.svg" alt="Hebern Logo" class="logo" />
    </div>

    <!-- Main About Message -->
    <div class="about-message">
      <h1 class="about-title">About Hebern</h1>
      <p class="about-subtitle">
        Securing the future of application development
      </p>
    </div>

    <!-- About Content Card -->
    <div class="about-card">
      <div class="card-content">
        <!-- The Legacy Section -->
        <div class="legacy-section">
          <h2 class="legacy-title">The Legacy</h2>
          <div class="legacy-content">
            <p>
              During his incarceration in San Quentin Prison from 1908 to 1909 for horse thievery, Edward Hebern first conceived his groundbreaking ideas for more secure encryption technologies. Upon his release, he pursued these concepts with determination, filing several patents between 1912 and 1917. These efforts culminated in a major breakthrough: sketches and patents for an electric rotor machine that promised unprecedented cryptographic strength.
            </p>
            <p>
              In 1918, Hebern built his first prototype—just as inventors in Germany were filing the initial patents for the infamous Enigma machine. Throughout the 1920s and 1930s, the U.S. military expressed keen interest in Hebern's innovations. Behind the scenes, William F. Friedman, a prominent U.S. Army cryptanalyst, meticulously examined the machines. He identified potential vulnerabilities and devised methods to crack them, insights that proved invaluable.
            </p>
            <p>
              Friedman's analysis not only bolstered the Allies' efforts to break the Enigma code during World War II but also inspired the development of the Allies' own legendary encryption device, SIGABA. Remarkably, SIGABA's security remained unbroken throughout its operational lifespan. The advent of rotor machines like these revolutionized cryptography, enabling far more secure communications. Their automated calculations and randomization generated exponentially more permutations, all while maintaining speed and accessibility for the intended recipients.
            </p>
            <p>
              We honor Edward Hebern's pivotal contributions to this cryptographic leap forward through our company name and logo. The logo proudly incorporates elements from Hebern's original patent sketches of his rotor design.
            </p>
          </div>
        </div>

        <h2>Our Mission</h2>
        <p>
          In an era where AI accelerates development at unprecedented speeds,
          security often takes a backseat. Hebern bridges this gap by providing
          automatic encryption services that ensure your applications are both
          fast and secure.
        </p>

        <h2>What We Do</h2>
        <p>
          Hebern offers seamless encryption solutions that integrate directly
          into your development workflow. We separate the data from the encryption 
          process and keys, ensuring your data is safe even from ai with behind the scenes access.
        </p>

        <h2>Why Hebern?</h2>
        <ul class="benefits-list">
          <li>Automatic encryption without slowing down development</li>
          <li>Compliance-ready security out of the box</li>
          <li>Easy integration with existing applications</li>
          <li>Secure data from AI with access</li>
        </ul>
      </div>
    </div>

    <!-- Contact Section -->
    <div class="contact-section">
      <h3>Get in Touch</h3>
      <p>Have questions? We'd love to hear from you.</p>
      <p class="email-link">
        <a href="mailto:support@hebern.com">support@hebern.com</a>
      </p>
    </div>
  </div>
</div>
